export default "__VITE_ASSET__9b3d25cf__"